<template>
  <v-card
    class="mb-5"
    color="transparent"
    flat
  >
    <v-form
      novalidate
      ref="form"
      v-model="valid"
      @submit.prevent
    >
      <v-card-text>
        <p class="mt-5">
          {{header}}
        </p>
        <v-row>
          <v-col cols="12">
            <v-textarea
              auto-grow
              outlined
              rows="8"
              v-model="form.text"
              :rules="rules.text"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row align="center" justify="space-between">
          <v-col cols="12" :md="inputColSize">
            <v-text-field
              dense
              label="Name"
              v-model="form.author"
              :rules="rules.author"
            ></v-text-field>
          </v-col>
          <v-col cols="12" :md="inputColSize">
            <v-text-field
              dense
              label="Email"
              v-model="form.email"
              :rules="rules.email"
            ></v-text-field>
          </v-col>
          <v-col cols="12" :md="inputColSize" v-if="!disableRatings">
            <v-select
              dense
              label="Rating"
              item-text="label"
              item-value="value"
              :items="ratings"
              v-model="form.rating"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          v-if="!disableCancel"
          @click="onCancel"
        >Cancel</v-btn>
        <v-btn
          color="primary"
          depressed
          :disabled="!valid"
          @click="onSubmit"
        >Submit</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCol,
  VForm,
  VRow,
  VSelect,
  VSpacer,
  VTextarea,
  VTextField,
} from 'vuetify/lib'

import { Validators } from '@/utils/validators'

export default {
  components: {
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCol,
    VForm,
    VRow,
    VSelect,
    VSpacer,
    VTextarea,
    VTextField,
  },
  computed: {
    header() {
      return this.title || 'Leave a comment (Your email address will not be published).'
    },
    inputColSize() {
      return this.disableRatings ? 6 : 4
    },
  },
  data: () => ({
    form: {
      'email': '',
      'author': '',
      'rating': 0,
      'text': '',
    },
    rules: {
      author: [
        value => Validators.required(value) || 'Name is required.'
      ],
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ],
      text: [
        value => Validators.required(value) || 'Comment is required.'
      ],
    },
    valid: false,
    ratings: [
      {label: 'No Rating', value: 0},
      {label: '1', value: 1},
      {label: '2', value: 2},
      {label: '3', value: 3},
      {label: '4', value: 4},
      {label: '5', value: 5},
    ]
  }),
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', {
          author: this.form.author,
          email: this.form.email,
          rating: this.form.rating,
          text: this.form.text,
        })
        this.$refs.form.reset()
      }
    },
  },
  mounted() {
    this.form.rating = this.ratings[0].value
  },
  props: {
    title: {
      default: '',
      type: String,
    },
    disableCancel: Boolean,
    disableRatings: Boolean,
  }
}
</script>
